"use strict";
import ErrorBoundary from "components/ErrorBoundary";
import { SwitchLocaleLink } from "components/SwitchLocaleLink";
import { PageWrapper } from "components/swap/styled";
import { Suspense, lazy } from "react";
import { useLocation } from "react-router-dom";
import { Flex } from "ui/src";
const SwapWidgetLazy = lazy(() => import("@deli/llamaswap").then((m) => ({ default: m.SwapWidget })));
export default function SwapPage() {
  const location = useLocation();
  return <>
      <PageWrapper>
        <ErrorBoundary fallback={() => null}>
          <Suspense fallback={null}>
            <Flex
    maxWidth="1000px"
    width="100%"
    $md={{
      maxWidth: "480px"
    }}
    $sm={{
      maxWidth: "380px"
    }}
  >
              <SwapWidgetLazy mobileOnly showChart />
            </Flex>
          </Suspense>
        </ErrorBoundary>
      </PageWrapper>
      {location.pathname === "/swap" && <SwitchLocaleLink />}
    </>;
}
